import { AxiosError } from 'axios'

export function hasResponseStatusCode(error: unknown, code: number) {
  return isAxiosResponseError(error) && error.response?.status === code
}

export function isAxiosResponseError(error: unknown): error is AxiosError {
  return (error as AxiosError)?.response !== undefined
}
